'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(Object.assign({
  __proto__: null
}, keyMirror({
  NO_SELECTION: null,
  SELECTIONS_FROM_MULTIPLE_NODES: null,
  SELECTIONS_SKIP_ROWS: null,
  SELECTIONS_CROSS_SECTION_DELIMITERS: null,
  SELECTIONS_NOT_RECTANGULAR: null,
  SELECTIONS_INCLUDE_ROOT: null,
  SELECTIONS_INCLUDE_SECTION_DELIMITER: null,
  SELECTIONS_WITHIN_FLEX_COLUMN: null
})));